import { Boundaries } from "@planzone/core";
import { Group, Identifiable } from "@planzone/dto";

function handleRemoveResourceFromProjectSucceeded(
  group: Identifiable<Group>,
  { projectResource }: Boundaries["removeResourceFromProject"]["success"],
): Identifiable<Group> {
  return {
    ...group,
    resources:
      group.resourceType === "project"
        ? group.resources.filter(
            ({ resource }) => resource.uuid !== projectResource.resource.uuid,
          )
        : group.resources,
  };
}

export { handleRemoveResourceFromProjectSucceeded };
